export interface KeyBinding {
  code: string;
  /** Let held-key auto-repeat through (off for race taps — one press, one tap). */
  allowRepeat?: boolean;
  /** Fire even while a .modal-backdrop is open (results-screen keys). */
  inModal?: boolean;
  handler: (event: KeyboardEvent) => void;
}

/**
 * BoomTown's discrete-action tier, packaged per scene: bind on enter,
 * unbind on exit. Ignores typing targets and suppresses everything under
 * an open modal unless a binding opts in.
 */
export function bindKeys(bindings: KeyBinding[]): () => void {
  const onKeyDown = (event: KeyboardEvent): void => {
    const target = event.target;
    if (
      target instanceof HTMLInputElement ||
      target instanceof HTMLTextAreaElement ||
      target instanceof HTMLSelectElement
    ) {
      return;
    }
    const modalOpen = document.querySelector('.modal-backdrop') !== null;
    for (const binding of bindings) {
      if (binding.code !== event.code) continue;
      if (event.repeat && !binding.allowRepeat) return;
      if (modalOpen && !binding.inModal) return;
      event.preventDefault();
      binding.handler(event);
      return;
    }
  };
  window.addEventListener('keydown', onKeyDown);
  return () => window.removeEventListener('keydown', onKeyDown);
}
